"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankField = void 0;
var BankField;
(function (BankField) {
    BankField["IBAN"] = "IBAN";
    BankField["ACCOUNT_NUMBER"] = "Account Number";
    BankField["SWIFT"] = "SWIFT";
    BankField["NATIONAL_BANK_CODE"] = "National Bank Code";
    BankField["ADDRESS"] = "Address";
})(BankField = exports.BankField || (exports.BankField = {}));
